
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/school/calendar",
      function () {
        return require("private-next-pages/school/calendar.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/school/calendar"])
      });
    }
  